module.exports = __webpack_public_path__ + "static/media/Desktop6.dfee31d5.jpg";